import { types } from 'mobx-state-tree'

export const MedalStats = types.model('MedalStats').props({
  level: types.maybeNull(types.string),
  percent: types.number,
  user_count: types.number,
  order: types.number,
})
